<template lang="html">

	<footer class="footer">

		<div class="footer-container row-between" :withoutMT="withoutMT">

			<div class="top row-center">
				<p>Universidad Politécnica de Madrid ©{{currentYear}}</p>
			</div>
			<nav class="bottom row-center" v-if="!!links">
				<template v-for="(data, key) in links">
					<template v-if="key == 'Política de protección de datos personales'">
						<a :href="server+data" target="_blank">{{key}}</a>
					</template>
					<template v-else>
						<a :href="data" target="_blank">{{key}}</a>
					</template>
				</template>
				<!-- <idioma v-if="brand.languagebydefault"></idioma> -->
				
			</nav>

		</div>

		<p class="version">v.{{version}}</p>


	</footer>

</template>

<script lang="js">
	
	import {mapGetters} from 'vuex';
	

	import idioma from '@/components/parts/idioma';

	export default  {
		name: 'app-footer',
		computed : {
			...mapGetters({
				colors : 'basicColors',
				texts : 'getFooterText',
				links : 'getFooterLinks',
				version : 'getVersion',
				brand : 'getBrand',
				server : 'getServer'
			}),
			currentYear() {
				return new Date().getFullYear();
			},
			ownstyles : function(){
				return {
					bgWhite : {
						background : this.colors.white
					}
				}
			},
			withoutMT : function(){
				let views = [
				'/login',
				'/login/empresas',
				'/login/antiguos',
				'/login/alumnos',
				'/mantenimiento',
				'/acceso',
				'/gma2019',
				];
				return (views.some(el => el == this.$route.path));
			}
		},
		components : {
			'idioma' : idioma
		}
	}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue